import { render, staticRenderFns } from "./WorkerSidebar.vue?vue&type=template&id=2be227d4"
import script from "./WorkerSidebar.vue?vue&type=script&lang=ts"
export * from "./WorkerSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports